<script>
    import SelectorForm from './modell-selector'
    import ModellApi from '../modell-api'

    export default {
        components: {
            'modell-selector': SelectorForm
        },        
        data: function () {
            return {
                loading: true,
                publishMode: true
            };
        },

        computed: {
            isVisible: function () {
                return true;
            }
        },
        mounted: function () {
            console.log("Is App in publish mode?: " + this.$parent.publishMode);
            this.publishMode = this.$parent.publishMode;
        },
        created: function () {

        },
        methods: {
            addModel: function (plid) {
                console.log("adding model : " + plid);
                this.$refs.selectorForm.addModel(plid);
            },
            removeModel: function (plid) {
                console.log("remove model : " + plid);
                this.$refs.selectorForm.removeModel(plid);
            },
            selectModel: function (plid) {
                console.log("select model : " + plid);
                this.$refs.selectorForm.selectModel(plid);
            }
        }
    }
</script>

<template>
    <div id="model-register-app">
        <modell-selector v-if="!publishMode" ref="selectorForm"></modell-selector>
    </div>
</template>

<style lang="scss">
    #model-register-app {
        
    }
</style>